module.exports = __webpack_public_path__ + "static/media/LogoSponsor-02.1ad18f98.png";